/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface FlipFilterRequest {
  flipTime?: string;
  minProfitAmount?: string;
  minProfitPercent?: string;
  notary?: string;
  brokerPercent?: string;
  rentFees?: string;
  maintenanceFees?: string;
  portalFees?: string;
  photographerAmount?: string;
  saleBrokerPercent?: string;
  renovationFrom1To30Amount?: string;
  renovationFrom30To40Amount?: string;
  renovationFrom40To50Amount?: string;
  renovationFrom50To60Amount?: string;
  renovationFrom60PlusAmount?: string;
  pcc?: string;
  /**
   * @format double
   * @min 1
   */
  certainPrice?: number;
  /** @format double */
  userOption?: number;
  /**
   * @format int64
   * @min 1
   */
  saleId?: number;
}

export interface FlipFilter {
  /** @format int64 */
  id?: number;
  flipTime?: string;
  renovationFrom1To30Amount?: string;
  renovationFrom30To40Amount?: string;
  renovationFrom40To50Amount?: string;
  renovationFrom50To60Amount?: string;
  renovationFrom60PlusAmount?: string;
  user?: SaleUser;
  minProfitAmount?: string;
  minProfitPercent?: string;
  notary?: string;
  brokerPercent?: string;
  rentFees?: string;
  maintenanceFees?: string;
  portalFees?: string;
  photographerAmount?: string;
  saleBrokerPercent?: string;
  pcc?: string;
  certainPrice?: number;
  userOption?: number;
  sale?: SaleFlat;
}

export interface SaleFlat {
  /** @format int64 */
  id?: number;
}

export interface SaleUser {
  /** @format int64 */
  id?: number;
}

export interface CalculatorFilterRequestUpdate {
  flipTime: string;
  minProfitAmount: string;
  minProfitPercent: string;
  notary: string;
  brokerPercent: string;
  rentFees: string;
  maintenanceFees: string;
  portalFees: string;
  photographerAmount: string;
  saleBrokerPercent: string;
  renovation: string;
  pcc: string;
  /**
   * @format double
   * @min 1
   */
  certainPrice: number;
  /**
   * @format double
   * @min 1
   */
  price: number;
  /**
   * @format double
   * @min 1
   */
  area: number;
  /** @format double */
  userOption?: number;
  address?: string;
  name?: string;
  /**
   * @format int64
   * @min 1
   */
  filterId?: number;
}

export interface SaleFlatDtoFilterCalculation {
  /** @format int64 */
  saleId?: number;
  /** @format int64 */
  userId?: number;
  /** @format double */
  offerPrice?: number;
  /**
   * @format double
   * @min 1
   */
  price?: number;
  /**
   * @format double
   * @min 1
   */
  area?: number;
  isForRenovation?: boolean;
}

export interface SaleFlatDtoParamCalculation {
  /**
   * @format double
   * @min 1
   */
  price?: number;
  /**
   * @format double
   * @min 1
   */
  area?: number;
  /**
   * @format double
   * @min 0
   */
  paramValue?: number;
  /**
   * @format double
   * @min 0
   */
  maxPurchasePrice?: number;
  /**
   * @format double
   * @min 0
   */
  certainPrice?: number;
}

export interface CalculatorFilterRequestCommon {
  flipTime: string;
  minProfitAmount: string;
  minProfitPercent: string;
  notary: string;
  brokerPercent: string;
  rentFees: string;
  maintenanceFees: string;
  portalFees: string;
  photographerAmount: string;
  saleBrokerPercent: string;
  renovation: string;
  pcc: string;
  /**
   * @format double
   * @min 1
   */
  certainPrice: number;
  /**
   * @format double
   * @min 1
   */
  price: number;
  /**
   * @format double
   * @min 1
   */
  area: number;
  /** @format double */
  userOption?: number;
  address?: string;
  name?: string;
}

export enum CalculateParamValueParamsParamEnum {
  MAINTENANCE_FEES = "MAINTENANCE_FEES",
  RENT_FEES = "RENT_FEES",
  BROKER = "BROKER",
  SALE_BROKER = "SALE_BROKER",
  MIN_PROFIT_PERCENT = "MIN_PROFIT_PERCENT",
  RENOVATION = "RENOVATION",
  RENOVATIONFROM130 = "RENOVATION_FROM_1_30",
  RENOVATIONFROM3040 = "RENOVATION_FROM_30_40",
  RENOVATIONFROM4050 = "RENOVATION_FROM_40_50",
  RENOVATIONFROM5060 = "RENOVATION_FROM_50_60",
  RENOVATIONFROM60PLUS = "RENOVATION_FROM_60_PLUS",
  PCC = "PCC",
  FLIP_TIME = "FLIP_TIME",
  MIN_PROFIT_AMOUNT = "MIN_PROFIT_AMOUNT",
  NOTARY = "NOTARY",
  PORTAL_FEES = "PORTAL_FEES",
  PHOTOGRAPHER_AMOUNT = "PHOTOGRAPHER_AMOUNT",
  REMAINING = "REMAINING",
}

export enum CalculateParamValueParamsEnum {
  MAINTENANCE_FEES = "MAINTENANCE_FEES",
  RENT_FEES = "RENT_FEES",
  BROKER = "BROKER",
  SALE_BROKER = "SALE_BROKER",
  MIN_PROFIT_PERCENT = "MIN_PROFIT_PERCENT",
  RENOVATION = "RENOVATION",
  RENOVATIONFROM130 = "RENOVATION_FROM_1_30",
  RENOVATIONFROM3040 = "RENOVATION_FROM_30_40",
  RENOVATIONFROM4050 = "RENOVATION_FROM_40_50",
  RENOVATIONFROM5060 = "RENOVATION_FROM_50_60",
  RENOVATIONFROM60PLUS = "RENOVATION_FROM_60_PLUS",
  PCC = "PCC",
  FLIP_TIME = "FLIP_TIME",
  MIN_PROFIT_AMOUNT = "MIN_PROFIT_AMOUNT",
  NOTARY = "NOTARY",
  PORTAL_FEES = "PORTAL_FEES",
  PHOTOGRAPHER_AMOUNT = "PHOTOGRAPHER_AMOUNT",
  REMAINING = "REMAINING",
}

export enum CalculateParamValue1ParamsParamEnum {
  MAINTENANCE_FEES = "MAINTENANCE_FEES",
  RENT_FEES = "RENT_FEES",
  BROKER = "BROKER",
  SALE_BROKER = "SALE_BROKER",
  MIN_PROFIT_PERCENT = "MIN_PROFIT_PERCENT",
  RENOVATION = "RENOVATION",
  RENOVATIONFROM130 = "RENOVATION_FROM_1_30",
  RENOVATIONFROM3040 = "RENOVATION_FROM_30_40",
  RENOVATIONFROM4050 = "RENOVATION_FROM_40_50",
  RENOVATIONFROM5060 = "RENOVATION_FROM_50_60",
  RENOVATIONFROM60PLUS = "RENOVATION_FROM_60_PLUS",
  PCC = "PCC",
  FLIP_TIME = "FLIP_TIME",
  MIN_PROFIT_AMOUNT = "MIN_PROFIT_AMOUNT",
  NOTARY = "NOTARY",
  PORTAL_FEES = "PORTAL_FEES",
  PHOTOGRAPHER_AMOUNT = "PHOTOGRAPHER_AMOUNT",
  REMAINING = "REMAINING",
}

export enum CalculateParamValue1ParamsEnum {
  MAINTENANCE_FEES = "MAINTENANCE_FEES",
  RENT_FEES = "RENT_FEES",
  BROKER = "BROKER",
  SALE_BROKER = "SALE_BROKER",
  MIN_PROFIT_PERCENT = "MIN_PROFIT_PERCENT",
  RENOVATION = "RENOVATION",
  RENOVATIONFROM130 = "RENOVATION_FROM_1_30",
  RENOVATIONFROM3040 = "RENOVATION_FROM_30_40",
  RENOVATIONFROM4050 = "RENOVATION_FROM_40_50",
  RENOVATIONFROM5060 = "RENOVATION_FROM_50_60",
  RENOVATIONFROM60PLUS = "RENOVATION_FROM_60_PLUS",
  PCC = "PCC",
  FLIP_TIME = "FLIP_TIME",
  MIN_PROFIT_AMOUNT = "MIN_PROFIT_AMOUNT",
  NOTARY = "NOTARY",
  PORTAL_FEES = "PORTAL_FEES",
  PHOTOGRAPHER_AMOUNT = "PHOTOGRAPHER_AMOUNT",
  REMAINING = "REMAINING",
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "http://192.168.31.12:8080";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== "string" ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title OpenAPI definition
 * @version v0
 * @baseUrl http://192.168.31.12:8080
 */
export class Api<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  flip = {
    /**
     * @description Pobieranie filtra użytkownika
     *
     * @tags flip-filter-controller
     * @name FindFilter
     * @request GET:/flip
     * @secure
     */
    findFilter: (
      query?: {
        /**
         * Id ogłoszenia, do którego mamy przypisany indywidualny filtr
         * @format int64
         * @example 215
         */
        sale?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<FlipFilter, void>({
        path: `/flip`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Edycja i tworzenie filtrów
     *
     * @tags flip-filter-controller
     * @name Process
     * @request PUT:/flip
     * @secure
     */
    process: (data: FlipFilterRequest, params: RequestParams = {}) =>
      this.http.request<FlipFilter, void>({
        path: `/flip`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Usuwanie filtra
     *
     * @tags flip-filter-controller
     * @name Delete
     * @request DELETE:/flip
     * @secure
     */
    delete: (
      query?: {
        /**
         * Id ogłoszenia, do którego mamy przypisany indywidualny filtr
         * @format int64
         * @example 215
         */
        sale?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<FlipFilter, void>({
        path: `/flip`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Obliczanie opłacalności flipa dla podanego ogłoszenia
     *
     * @tags flip-filter-controller
     * @name Calculate
     * @request POST:/flip/calculate
     * @secure
     */
    calculate: (data: SaleFlatDtoFilterCalculation, params: RequestParams = {}) =>
      this.http.request<object, any>({
        path: `/flip/calculate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Obliczanie wartości filtra na podstawie wartości podanej prez użytkownika
     *
     * @tags flip-filter-controller
     * @name CalculateParamValue
     * @request POST:/flip/calculate/{param}
     * @secure
     */
    calculateParamValue: (
      param: CalculateParamValueParamsEnum,
      data: SaleFlatDtoParamCalculation,
      params: RequestParams = {},
    ) =>
      this.http.request<object, any>({
        path: `/flip/calculate/${param}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  calculation = {
    /**
     * @description Pobieranie listy zawierającą wszystkie filtry użytkownika
     *
     * @tags calculator-filter-controller
     * @name FindUserFilters
     * @request GET:/calculation
     * @secure
     */
    findUserFilters: (params: RequestParams = {}) =>
      this.http.request<object, any>({
        path: `/calculation`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Aktualizowanie danego filtra
     *
     * @tags calculator-filter-controller
     * @name UpdateFilter
     * @request PUT:/calculation
     * @secure
     */
    updateFilter: (data: CalculatorFilterRequestUpdate, params: RequestParams = {}) =>
      this.http.request<object, any>({
        path: `/calculation`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Tworzenie filtra
     *
     * @tags calculator-filter-controller
     * @name CreateFilter
     * @request POST:/calculation
     * @secure
     */
    createFilter: (data: CalculatorFilterRequestCommon, params: RequestParams = {}) =>
      this.http.request<object, any>({
        path: `/calculation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Obliczanie wartości filtra na podstawie wartości podanej prez użytkownika
     *
     * @tags calculator-filter-controller
     * @name CalculateParamValue1
     * @request POST:/calculation/value/{param}
     * @secure
     */
    calculateParamValue1: (
      param: CalculateParamValue1ParamsEnum,
      data: SaleFlatDtoParamCalculation,
      params: RequestParams = {},
    ) =>
      this.http.request<object, any>({
        path: `/calculation/value/${param}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Obliczanie wartości według filtra
     *
     * @tags calculator-filter-controller
     * @name CalculateByFilter
     * @request POST:/calculation/calculate
     * @secure
     */
    calculateByFilter: (data: CalculatorFilterRequestUpdate, params: RequestParams = {}) =>
      this.http.request<object, any>({
        path: `/calculation/calculate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Pobieranie szczegółów danego filtra
     *
     * @tags calculator-filter-controller
     * @name FindUserFilter
     * @request GET:/calculation/{filterId}
     * @secure
     */
    findUserFilter: (filterId: number, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/calculation/${filterId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Usuwanie danego filtra
     *
     * @tags calculator-filter-controller
     * @name DeleteFilter
     * @request DELETE:/calculation/{filterId}
     * @secure
     */
    deleteFilter: (filterId: number, params: RequestParams = {}) =>
      this.http.request<object, any>({
        path: `/calculation/${filterId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
